// extracted by mini-css-extract-plugin
export default {"container":"brand-logo-timeline_container__3YRw6","sponsor":"brand-logo-timeline_sponsor__3Pnf1"};